import React, { Component } from 'react';
import { FiPlus } from 'react-icons/fi'
import { connect } from 'react-redux';
import { objectsConstants as OC } from 'redux/constant/objects-constant';
import { Card } from "components/Card/Card.jsx";
import { helperFunctions as HF } from '../../../helper/helperFunctions';
import {
    Grid,
    Row,
    Col,
    // Tooltip,
    OverlayTrigger,
    Popover,
} from "react-bootstrap";
import { Modal } from "react-bootstrap";
import { SortableContainer, SortableElement, SortableHandle, arrayMove } from 'react-sortable-hoc';
// import arrayMove from 'array-move';
import { Link, withRouter } from 'react-router-dom';
import TransformationRulesForm from './TransformationRulesForm';
import { confirmAlert } from 'react-confirm-alert';
import Confirmalertfordelete from '../../ThemeComponents/confirmAlertForDelete';
import { brandActions } from '../../../redux/actions/brand-actions';
let _ = require('lodash');
// var Modal = require('react-bootstrap-modal');
const DragHandle = SortableHandle(() => <OverlayTrigger placement="bottom" overlay={<Popover id="tooltip">Click and Hold to Drag</Popover>}><span className="moveIcon orderDetailsAction"></span></OverlayTrigger>);
const SortableItem = SortableElement(({ value, deleteConfirmListItem, parentIndex }) => (

    <tr test1={`innerItem-${value.key}`} key={`innerItem-${value.key}`} >

        <td>{value.key + 1}</td>
        <td>
            <table className="table">
                <tbody>
                    {

                        <tr>
                            <td>{value.value['complete_rule']}</td>
                        </tr>
                    }
                </tbody>
            </table>
        </td>

        <td>
            <DragHandle />
            <OverlayTrigger placement="bottom" overlay={<Popover id="tooltip">Delete Row</Popover>}>
                <span>
                    <button onClick={() => { deleteConfirmListItem(value.key, parentIndex, value.value.id) }} className="deleteIcon orderDetailsAction">&nbsp;</button>
                </span>
            </OverlayTrigger>
        </td>
    </tr>
));

const SortableList = SortableContainer(({ sortable, setSortable, transformationRules, onInputHandler, deleteConfirmListItem, onCheckFlag, adjustable_array, rulesIndex }) => {
    return (
        <tbody>
            {
                transformationRules.map((value, index) => (

                    <SortableItem key={`item-${index}`} index={index} value={{ value: value, key: index }} test={`item-${index}`} onInputHandler={onInputHandler} deleteConfirmListItem={deleteConfirmListItem} onCheckFlag={onCheckFlag} adjustable_array={adjustable_array} collection={rulesIndex} parentIndex={rulesIndex} />

                ))
            }

        </tbody>
    );
});
class TransformationRules extends Component {

    constructor(props) {
        super(props);
        this.fileInput = React.createRef();
        if (this.props.location.state === undefined) {
            this.props.history.push('/Admin/dashboard')
        } else {
            this.state = {
                addModal: false,
                brand_id: this.props.location.state ? this.props.location.state.brand_id : '',
                definition_id: this.props.match.params.data_definition_id,
                rules_type: window.location.href.includes('edit') ? 'edit' : 'add',
                transformationRules: [],
                attributesLookup: [],
                brand_product_attributes: this.props.location.state ?
                    HF.appendValues(
                        this.props.location.state.product_attributes,
                        [
                            { column: 'transformationRules', value: [] }
                        ]) : [],
                products: this.props.location.state ? this.props.location.state.product_attributes.map(item => {
                    return {
                        id: item.id,
                        title: item.title,
                        data_type: item.data_type,
                        db_column: item.db_column,
                    }
                }) : [{ id: 4, title: 'purchasing', data_type: 'string' },
                { id: 5, title: '5/5/2012', data_type: 'datetime' }],
                target_attribute: {},
                lookupTable: [{ title: 'titan', id: 1 },
                { title: 'rolex', id: 2 },
                { title: 'norton', id: 3 },
                ],
                lookupAttributes: [
                    { title: 'Description', id: 1 },
                    { title: 'Style', id: 2 },
                ],
            }
            this.props.getTransformationRulesListingCall(this.props.location.state.definition_id, 'data_definition')
            this.props.getBrandLookupDefinitionsDataCall(this.props.location.state.brand_id);
        }
    }

    setSortable = () => {
        this.setState({
            sortable: !this.state.sortable
        });
    }

    onSortEnd = ({ oldIndex, newIndex, collection }) => {
        const rule_filters = this.state.brand_product_attributes;
        const updated_filter = rule_filters[collection];
        updated_filter['transformationRules'] = arrayMove(updated_filter.transformationRules, oldIndex, newIndex);
        const sortedArray = updated_filter.transformationRules.map(data => {
            return data.id
        });
        const obj = {
            transformation_rules: sortedArray
        }
        if (oldIndex !== newIndex)
            this.props.sortTransformationRulesCall(obj);
        this.setState({
            brand_product_attributes: rule_filters
        })
    };

    handRulesSubmitForm = (data, formType) => {
        if (formType === 'add') {
            const products = this.state.brand_product_attributes;
            const updated_filter = products[this.state.productIndex];
            updated_filter['transformationRules'] = [...this.state.brand_product_attributes[this.state.productIndex].transformationRules, data];
            this.setState({
                ...this.state,
                brand_product_attributes: products,
                addModal: false,
            }, () => {
                this.props.getTransformationRulesListingCall(this.state.definition_id, 'data_definition')
            })
        }
    }

    deleteConfirmListItem = (id, index, ruleId) => {
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <Confirmalertfordelete typeName="rule" description={"Are you sure to delete this rule"} onClosePro={onClose} deleteType={() => this.onDeleteAttribute(id, index, ruleId)} />
                )
            }
        })
    }
    onDeleteAttribute = (key, index, ruleId) => {
        this.props.deleteTransformationRuleCall(ruleId).then(res => {
            this.props.getTransformationRulesListingCall(this.state.definition_id, 'data_definition')
        })
    }
    onAttributesSubmit = () => {
        this.props.location.state.delimiter !== 'rest' ?
            this.props.history.push({
                pathname: `/Admin/brand/${this.props.location.state.brand_id}/data-definitions`,
                state: {
                    brand_id: this.state.brand_id,
                }
            })
            :
            this.props.history.push({
                pathname: `/Admin/brand/${this.state.definition_id}/api_view`,
                state: {
                    brand_id: this.state.brand_id,
                    response: this.props.history.location.state.response,
                }
            })
    }
    createProductsTable(products) {
        return products.map((data, index) => {
            return <tr key={index} >
                <td style={{ verticalAlign: 'top' }}>
                    {
                        data.title
                    }
                </td>
                <td style={{ verticalAlign: 'top' }}>
                    {
                        data.data_type
                    }
                </td>
                <td>
                    {
                        data.sample_value
                    }
                    {
                        !_.isEmpty(data.transformationRules) &&
                        <div className="table-responsive">
                            <table className="table theme_table child_table">
                                <thead>
                                    <tr>

                                        <th>Rule Order</th>
                                        <th>Rule Expression</th>
                                        <th>Control</th>
                                    </tr>
                                </thead>
                                {
                                    <SortableList axis='y' transformationRules={data.transformationRules} onSortEnd={this.onSortEnd} onInputHandler={this.onInputHandler} deleteConfirmListItem={this.deleteConfirmListItem} onCheckFlag={this.onCheckFlag} adjustable_array={this.state.adjustable_array} rulesIndex={index} useDragHandle />
                                }
                            </table>
                        </div>
                    }
                </td>
                <td style={{ paddingBottom: '10px' }}>
                    {
                        /* <span style={{ cursor: 'pointer' }} className="text-sm" title="Add Rule" onClick={e => this.addRuleHandler(e, data, index)}>
                            <FiPlus />
                        </span> */
                        <span style={{ cursor: 'pointer' }} className="text-sm" title="Add Rule">
                            <Link to={{
                                pathname: `/Admin/brand/transformation-rules/addRule`,
                                state: {
                                    brandPro: OC.brand_order_attributes,
                                    formTypePro: "add",
                                    // handleSubmit: this.handRulesSubmitForm,
                                    targetAttribute: data,
                                    componentPro: 'Transformation',
                                    attributesProp: this.state.brand_product_attributes,
                                    adjustable_array: this.state.adjustable_array,
                                    definition_id: this.state.definition_id,
                                    lookupTables: this.state.lookupTable,
                                    lookupAttributes: this.state.lookupAttributes,
                                    attributesLookup: this.state.attributesLookup,
                                }
                            }}> <FiPlus />
                            </Link>
                        </span>
                    }
                </td>
            </tr>
        })

    }
    addRuleHandler = (e, data, index) => {
        this.setState({
            ...this.state,
            target_attribute: data,
            productIndex: index,
            addModal: true
        })
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.props.lookupDefinitionData !== prevProps.lookupDefinitionData && this.props.lookupDefinitionData !== undefined) {
            this.setState({
                attributesLookup: this.props.lookupDefinitionData
            })
        }

        if (this.props.transformationRulesData !== prevProps.transformationRulesData && this.props.transformationRulesData !== undefined) {
            const newArray = this.state.brand_product_attributes.map((data, index) => {
                if (this.props.transformationRulesData.hasOwnProperty(data.db_column)) {
                    data.transformationRules = this.props.transformationRulesData[data.db_column]
                    return data;
                }
                else {
                    data.transformationRules = [];
                    return data;
                }
            })
            this.setState({
                brand_product_attributes: newArray
            })
        }
    }

    render() {
        if (this.props.location.state === undefined) {
            return <div></div>
        }
        return (
            <div>
                <Grid fluid>
                    <Row>
                        <Col md={12}>
                            <Card
                                ctTableResponsive
                                content={
                                    <div>
                                        <Grid fluid>
                                            <Row>
                                                <Col md={12}>
                                                    <h3 style={{ textAlign: 'center', fontWeight: "500" }}>Manage Transformation Rules</h3>
                                                    <div>Using this form, you will be able to define transformation rules that will modify the incoming product/style feed</div>
                                                </Col>


                                                <Col md={12} className="mt-md">
                                                    <div className="table-responsive">
                                                        <table className="table theme_table blank table-striped mt-md" style={{ border: "1px solid #bebebe" }}>
                                                            <thead>
                                                                <tr>
                                                                    <th>Title</th>
                                                                    <th>Datatype</th>
                                                                    <th>Sample Value</th>
                                                                    <th>Control</th>
                                                                </tr>
                                                            </thead>

                                                            <tbody>
                                                                {this.createProductsTable(this.state.brand_product_attributes)}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </Col>

                                                {false &&
                                                    this.state.productIndex && !_.isEmpty(this.state.brand_product_attributes[this.state.productIndex].transformationRules) &&
                                                    <Col md={12} className="mt-md">
                                                        <div className="table-responsive">
                                                            <table className="table theme_table child_table">
                                                                <thead>
                                                                    <tr>

                                                                        <th>Rule Order</th>
                                                                        <th>Rule Expression</th>
                                                                        <th>Control</th>
                                                                    </tr>
                                                                </thead>

                                                                <tbody>
                                                                    {
                                                                        this.state.brand_product_attributes.map((data, index) =>
                                                                            <SortableList axis='y' transformationRules={data.transformationRules} onSortEnd={this.onSortEnd} onInputHandler={this.onInputHandler} deleteConfirmListItem={this.deleteConfirmListItem} onCheckFlag={this.onCheckFlag} adjustable_array={this.state.adjustable_array} useDragHandle />
                                                                        )

                                                                    }
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </Col>
                                                }
                                            </Row>
                                        </Grid>
                                        {/* Add Order Attribute */}
                                        {
                                            <Modal bsSize={'full'} show={this.state.addModal} onHide={HF.closeModal.bind(this, "addModal")} aria-labelledby="ModalHeader"
                                            >
                                                <Modal.Header closeButton>
                                                    <Modal.Title id='ModalHeader' className="headerTitle">Add Rule </Modal.Title>
                                                </Modal.Header>
                                                <Modal.Body>
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <TransformationRulesForm
                                                                closeModel={HF.closeModal.bind(this, "addModal")}
                                                                formTypePro="add"
                                                                brandPro={OC.brand_order_attributes}
                                                                handleSubmit={this.handRulesSubmitForm}
                                                                name={this.props.title}
                                                                targetAttribute={this.state.target_attribute}
                                                                componentPro={'Transformation'}
                                                                attributesProp={this.state.brand_product_attributes}
                                                                adjustable_array={this.state.adjustable_array}
                                                                definition_id={this.state.definition_id}
                                                                lookupTables={this.state.lookupTable}
                                                                lookupAttributes={this.state.lookupAttributes}
                                                                attributesLookup={this.state.attributesLookup}
                                                            />
                                                        </div>
                                                    </div>
                                                </Modal.Body>
                                            </Modal>
                                        }
                                    </div>
                                } />
                        </Col>
                    </Row>
                </Grid>
                <div className="col-md-12 text-center">
                    <button className="customBtn btnBlack m-md " onClick={() => { this.props.history.push(`/Admin/brand/${this.props.location.state.brand_id}/data-definitions`) }}>Go Back</button>
                    {
                        !_.isEmpty(this.state.brand_product_attributes) &&
                        <button className="customBtn btnBlue m-md " onClick={this.onAttributesSubmit}>Finish</button>
                    }
                </div>


            </div>
        );
    }
}
const mapDispatchToProps = dispatch => {
    return ({

        getBrandLookupDefinitionsDataCall: (id) => { return dispatch(brandActions.getBrandLookupDefinitionsData(id)) },
        deleteTransformationRuleCall: (id) => { return dispatch(brandActions.deleteTransformationRule(id)) },
        getTransformationRulesListingCall: (id, type) => { return dispatch(brandActions.getTransformationRulesListing(id, type)) },
        storeBrandDataDefinitionCall: (data, id) => { return dispatch(brandActions.storeBrandDataDefinition(data, id)) },
        sortTransformationRulesCall: (data) => { return dispatch(brandActions.sortTransformationRules(data)) }
    });
};
function mapStateToProps(state) {
    const { lookupDefinitionData, transformationRulesData } = state.brandReducer;
    return {
        lookupDefinitionData, transformationRulesData
    };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TransformationRules));



// WEBPACK FOOTER //
// ./src/components/Admin/Brands/TransformationRules.jsx